import classNames from 'classnames';
import type { CSSProperties } from 'react';
import * as styles from '../Recommendations.css';
import type { TRecommendationAttributes } from '../Recommendations.types';

const COLUMNS_MAP: Record<string, string> = {
  '1': 'grid-cols-1',
  '2': 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-2',
  '3': 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
  '4': 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
  '5': 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-5',
  '6': 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-6',
};

interface Props {
  children: React.ReactNode;
  attrs: TRecommendationAttributes;
}

const GridWrapper = ({ attrs, children }: Props) => {
  const { columns, gap, isFullHeight = true, listHeight } = attrs;

  return (
    <div
      className={classNames('grid', COLUMNS_MAP[columns || '3'], styles.listContainer)}
      style={
        {
          gap: gap,
          ...(!isFullHeight ? { '--list-max-height': listHeight, '--list-overflow': 'scroll' } : {}),
        } as CSSProperties
      }
    >
      {children}
    </div>
  );
};

export default GridWrapper;
